// extracted by mini-css-extract-plugin
export default {"customer-orders__search-input-container":"CustomerOrders_customer-orders__search-input-container__UVxK2"};